import { computed, Directive, input } from '@angular/core';
import { cn } from '@shared/helpers/cn';

@Directive({
  selector: '[appContainer]',
  standalone: true,
  host: { '[class]': 'styles()' },
})
export class AppContainerDirective {
  class = input<string>();

  public styles = computed(() => {
    return cn(
      'mx-auto pt-10 flex max-w-6xl flex-col gap-4 pb-10 px-2',
      this.class(),
    );
  });
}
